import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Login = resolve => require(['../views/main/login.vue'],resolve);
const Main = resolve => require(['../views/main/main.vue'],resolve);
const Index = resolve => require(['../views/main/index.vue'],resolve);
const interfaceDetail = resolve => require(['../views/pageDetail/interfaceDetail.vue'],resolve);
const deviceDetail = resolve => require(['../views/pageDetail/deviceDetail.vue'],resolve);

export default new Router({
    routes: [{
        path: '/',
        name: 'Main',
        meta:{
            requireAuth: true
        },
        component: Main,
        children:[{
            path: '/Index',
            name: 'Index',
            meta:{
                requireAuth: true,
                title: '首页'
            },
            component: Index,
        },{
            path: '/interfaceDetail',
            name: 'interfaceDetail',
            meta:{
                requireAuth: true,
                title: '接口访问详情'
            },
            component: interfaceDetail,
        },{
            path: '/deviceDetail',
            name: 'deviceDetail',
            meta:{
                requireAuth: true,
                title: '设备列表详情'
            },
            component: deviceDetail,
        }]
    },{
        path: '/Login',
        name: 'Login',
        component: Login,
        meta:{
            title: '登录'
        }
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js